import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b123f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manga-info" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "middle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "character-title" }, "角色", -1 /* HOISTED */))
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { class: "btn-box bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.banner.length)
        ? (_openBlock(), _createBlock(_component_el_carousel, {
            key: 0,
            class: "carousel",
            interval: $setup.interval,
            type: $setup.carouselType
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.banner, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                  class: "banner-box",
                  key: item
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "banner",
                      src: item.blob,
                      alt: "banner"
                    }, null, 8 /* PROPS */, _hoisted_3)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */)),
              _createCommentVNode(" 使用一张图片撑开容器的高度 "),
              _createElementVNode("img", {
                class: "banner seat",
                src: $setup.banner.length ? $setup.banner[0].blob : '',
                alt: "banner"
              }, null, 8 /* PROPS */, _hoisted_4)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["interval", "type"]))
        : (_openBlock(), _createBlock(_component_el_image, {
            key: 1,
            class: "anim cover-img",
            src: $setup.mangaCover
          }, null, 8 /* PROPS */, ["src"]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      ($setup.character.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "character",
            onWheel: $setup.character_wheel
          }, [
            _hoisted_6,
            _createVNode(_component_perfect_scrollbar, {
              class: "character-scroll",
              onWheel: $setup.character_wheel,
              options: { suppressScrollX: false, suppressScrollY: true }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.character, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "character-item",
                    key: item.characterId
                  }, [
                    _createElementVNode("img", {
                      src: item.blob,
                      alt: item.characterName
                    }, null, 8 /* PROPS */, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(item.characterName), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(item.description), 1 /* TEXT */)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ], 32 /* HYDRATE_EVENTS */))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_el_descriptions, {
        class: "meta-info",
        title: "漫画信息",
        column: $setup.infoColum
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "漫画名称" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.title), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "作者" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.author), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "发布时间" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.publishDate), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "章节总数" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.chapterCount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "阅读方式" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.browseType), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "入库时间" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.createTime), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "更新时间" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.updateTime), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "评分" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.star), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "标签" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tags, (item) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: item.tagId,
                  class: "tag",
                  size: "small",
                  color: item.tagColor
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.tagName), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_descriptions_item, { label: "简介" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.mangaInfo.describe), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["column"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_button, {
        class: "btn",
        type: "primary",
        onClick: $setup.go_chapter_list
      }, {
        default: _withCtx(() => [
          _createTextVNode("章节列表")
        ]),
        _: 1 /* STABLE */
      }),
      ($setup.latestChapterInfo)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "btn",
            type: "warning",
            onClick: $setup.go_chapter
          }, {
            default: _withCtx(() => [
              _createTextVNode("继续阅读")
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            class: "btn",
            type: "success",
            onClick: $setup.go_chapter
          }, {
            default: _withCtx(() => [
              _createTextVNode("开始阅读")
            ]),
            _: 1 /* STABLE */
          })),
      ($setup.isCollect)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            class: "btn",
            type: "warning",
            onClick: $setup.remove_collect
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消收藏")
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            class: "btn",
            type: "success",
            onClick: $setup.collect_manga
          }, {
            default: _withCtx(() => [
              _createTextVNode("收藏漫画")
            ]),
            _: 1 /* STABLE */
          })),
      _createVNode(_component_el_button, {
        class: "btn",
        type: "primary",
        onClick: $setup.open_tag_box
      }, {
        default: _withCtx(() => [
          _createTextVNode("编辑标签")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.$t('rightSidebar.editTags'),
      modelValue: $setup.editTagsDialog,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.editTagsDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode($setup["mangaTagBox"], {
          mangaId: $setup.mangaInfo.mangaId,
          tags: $setup.tags,
          onUpdate_tags: $setup.update_tags
        }, null, 8 /* PROPS */, ["mangaId", "tags"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "modelValue"])
  ]))
}